import React, { useState } from 'react'
import { CFormSwitch, CSmartTable } from '@coreui/react-pro'
import ToastComponent from 'src/components/common/TaostComponent.js'
import SponsorService from 'src/service/SponsorService'

const GameSponsorTable = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnFilter,
  itemsPerPage,
  activePage,
  loading,
}) => {
  const API_URL = process.env.REACT_APP_API_URL
  const [updatingId, setUpdatingId] = useState(null)

  // gameSponsorListing only filters on `name` and does not read a `sort` param, so every
  // other column stays display-only instead of offering controls the API ignores.
  const columns = [
    {
      label: 'Logo',
      key: 'logo',
      _style: { width: '10%' },
      filter: false,
      sorter: false,
    },
    { key: 'name', _style: { width: '35%' }, sorter: false },
    { label: 'Website', key: 'website', filter: false, sorter: false },
    {
      label: 'Show in Game',
      key: 'is_active',
      _style: { width: '15%' },
      filter: false,
      sorter: false,
    },
  ]

  const handleStatus = (id, status) => {
    setUpdatingId(id)
    SponsorService.updateStatus(id, status)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .catch((e) => {
        console.log('Catch Block', e)
      })
      .finally(() => {
        setUpdatingId(null)
      })
  }

  const totalPages = Math.ceil((users?.total || 0) / itemsPerPage)
  const showPagination = totalPages > 1

  return (
    <div className="ge-datatable ge-datatable--static">
      <CSmartTable
        columns={columns}
        columnFilter={{
          external: true,
        }}
        scopedColumns={{
          logo: (item) => (
            <td>
              {item.logo ? (
                <img
                  src={`${API_URL}uploads/sponsor/${item.logo}`}
                  alt="sponsor"
                  width="40"
                  height="40"
                  className="rounded"
                />
              ) : (
                <span className="text-medium-emphasis">—</span>
              )}
            </td>
          ),
          name: (item) => (
            <td>
              <span className="fw-semibold">{item.name}</span>
            </td>
          ),
          website: (item) => (
            <td>
              {item.website ? (
                <a href={item.website} target="_blank" rel="noreferrer">
                  {item.website}
                </a>
              ) : (
                <span className="text-medium-emphasis">—</span>
              )}
            </td>
          ),
          is_active: (item) => (
            <td>
              <CFormSwitch
                id={`sponsor_status_${item.id}`}
                label={item.is_active === 1 ? 'Activated' : 'Deactivated'}
                checked={item.is_active === 1}
                disabled={updatingId === item.id}
                onChange={(e) => handleStatus(item.id, e.target.checked ? 1 : 0)}
              />
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={showPagination ? { external: true } : false}
        paginationProps={
          showPagination
            ? {
                activePage: activePage,
                pages: totalPages,
              }
            : undefined
        }
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
      />
    </div>
  )
}

export default GameSponsorTable
